import { render, staticRenderFns } from "./IndexHyData.vue?vue&type=template&id=b4840a7c&scoped=true"
import script from "./IndexHyData.vue?vue&type=script&lang=js"
export * from "./IndexHyData.vue?vue&type=script&lang=js"
import style0 from "./IndexHyData.vue?vue&type=style&index=0&id=b4840a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4840a7c",
  null
  
)

export default component.exports